import moment from 'moment-timezone';

export const getAssignmentDate = (date, timezone) => (
  moment.tz(date, timezone).format('YYYY-MM-DD')
);

export const getAssignmentMinEndDate = (startDate, timezone) => {
  const assignmentStarted = moment.tz(startDate, timezone).isBefore(moment.tz(timezone));
  if (assignmentStarted) {
    // Calculate date from today
    return moment.tz(timezone).format('YYYY-MM-DD');
  }
  // Calculate date from assignment start date
  return moment.tz(startDate, timezone).format('YYYY-MM-DD');
};

export const getAssignmentTime = (date, timezone) =>
  moment.tz(date, timezone).format('HH:mm');

export const getAssignmentWorkingDays = job => {
  return job && job.days && job.days.reduce((results, day, currentIndex) => {
    if (day.selected) results.push(`${currentIndex}`);
    return results;
  }, []) || [];
};

export const getJobDate = (job, timezone) => {
  const shiftStartDate = moment(job.start_date_time).tz(timezone).format('MMM D');
  const shiftEndDate = moment(job.end_date_time).tz(timezone).format('MMM D');
  const formattedShiftDate = `${shiftStartDate} - ${shiftEndDate}`;
  const shiftStartTime = moment(job.start_date_time).tz(timezone).format('h:mm a');
  const shiftEndTime = moment(job.end_date_time).tz(timezone).format('h:mm a');
  const formattedShiftTime = `${shiftStartTime} – ${shiftEndTime}`;
  return `${formattedShiftDate}, ${formattedShiftTime}`;
};
